import { Pipe, type PipeTransform } from '@angular/core';
import {
  type Product,
  getFullDescription,
} from '../../core/services/products/product.interface';

@Pipe({
  name: 'productTitle',
  pure: true,
})
export class ProductTitlePipe implements PipeTransform {
  transform(product: Product | undefined | null): string {
    if (!product) return '';
    return getFullDescription(product);
  }
}
